// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.hero-swiper-nav-wrapper {
        position: relative;
}
.hero-swiper-nav-wrapper .swiper-button-next,
    .hero-swiper-nav-wrapper .swiper-button-prev {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 5;
}
.hero-swiper-nav-wrapper .swiper-button-next {
        right: 10px;
}
.hero-swiper-nav-wrapper .swiper-button-prev {
        left: 10px;
}
.ce-block .ce-block--focused {
        border: 1px dashed #cbcbcb !important
}
#editorjs {
        color: green;
}
.slider-content-box-action {
        float: right !important;
        margin-bottom: 10px !important;
        margin-right: 10px !important;
}
.mce-content-body [data-mce-selected=inline-boundary] {
        background-color: unset !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
